import { createContext, useContext, useState, useEffect, useCallback } from 'react'
import { financialsApi } from '../services/api'
import { useAuth } from './AuthContext'

const NotificationContext = createContext({
  pendingRequestCount: 0,
  refreshNotifications: () => {}
})

export function NotificationProvider({ children }) {
  const { user, isAdmin } = useAuth()
  const [pendingRequestCount, setPendingRequestCount] = useState(0)

  const refreshNotifications = useCallback(async () => {
    if (!user || !isAdmin) {
      setPendingRequestCount(0)
      return
    }

    try {
      const response = await financialsApi.getRequestStats()
      if (response.data?.stats) {
        // Count pending + in_progress as actionable items
        // Parse as integers since API may return strings
        const pending = parseInt(response.data.stats.pending) || 0
        const inProgress = parseInt(response.data.stats.in_progress) || 0
        setPendingRequestCount(pending + inProgress)
      }
    } catch (error) {
      console.error('Failed to fetch notification count:', error)
    }
  }, [user, isAdmin])

  // Poll for notifications every 30 seconds
  useEffect(() => {
    if (!user || !isAdmin) return

    // Initial fetch
    refreshNotifications()

    // Set up polling
    const interval = setInterval(refreshNotifications, 30000)

    return () => clearInterval(interval)
  }, [user, isAdmin, refreshNotifications])

  return (
    <NotificationContext.Provider value={{ pendingRequestCount, refreshNotifications }}>
      {children}
    </NotificationContext.Provider>
  )
}

export function useNotifications() {
  return useContext(NotificationContext)
}
